// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"progress_wrapper__VncJj","internal-wrapper":"progress_internal-wrapper__7JCI1","ud-progress":"progress_ud-progress__P9zgh","rounded":"progress_rounded__e85TI"};